<template>
  <div class="module-box case-list">
    <p class="title">他们都在用知链</p>
    <p class="s-title">（*排名不分先后顺序）</p>
    <div class="list-box">
      <div v-for="(item, index) in 18" :key="`cl_` + index" class="case">
        <div class="img-box">
          <img
            :src="require('@/assets/images/case_logo_1.png')"
            alt=""
            class="origin-img"
          />
          <img
            :src="require('@/assets/images/wxb.png')"
            alt=""
            class="hover-img"
          />
        </div>
        <p>吴晓波频道</p>
      </div>
    </div>
    <a href="/" class="more-client">查看更多案例 &gt;</a>
  </div>
</template>

<script>
export default {

};
</script>

<style>
</style>
